(function() {
  'use strict';

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function formatMoney(cents, format) {
    cents = parseInt(cents, 10) || 0;

    var amount = (cents / 100).toFixed(2);
    var amountComma = amount.replace('.', ',');
    var amountNoDecimals = Math.round(cents / 100).toString();

    return (format || '{{amount}} €')
      .replace('{{amount_with_comma_separator}}', amountComma)
      .replace('{{amount_no_decimals_with_comma_separator}}', amountNoDecimals)
      .replace('{{amount_no_decimals}}', amountNoDecimals)
      .replace('{{amount}}', amount);
  }

  function readCents(value) {
    var n = parseInt(value, 10);
    return isNaN(n) ? 0 : n;
  }

  function ensureCompareAfter(priceEl, selector, className) {
    if (!priceEl) return null;

    var parent = priceEl.parentNode;
    if (!parent) return null;

    var el = parent.querySelector(selector);
    if (el) return el;

    el = document.createElement('s');
    el.className = className;
    el.setAttribute(selector.replace('[', '').replace(']', ''), '');
    el.style.display = 'none';
    parent.appendChild(el);

    return el;
  }

  function updateMoneyDisplays(section, data, totalPrice, comparePrice) {
    totalPrice = readCents(totalPrice);
    comparePrice = readCents(comparePrice);

    var formattedPrice = formatMoney(totalPrice, data.moneyFormat);
    var formattedCompare = comparePrice > totalPrice ? formatMoney(comparePrice, data.moneyFormat) : '';

    var priceEl = section.querySelector('[data-wbp-price]');
    var atcPriceEl = section.querySelector('[data-wbp-atc-price]');
    var stickyPrice = section.querySelector('[data-wbp-sticky-price]');

    var compareEl = section.querySelector('[data-wbp-compare]') || ensureCompareAfter(priceEl, '[data-wbp-compare]', 'wb-product__compare');
    var atcCompareEl = section.querySelector('[data-wbp-atc-compare]') || ensureCompareAfter(atcPriceEl, '[data-wbp-atc-compare]', '');
    var stickyCompare = section.querySelector('[data-wbp-sticky-compare]') || ensureCompareAfter(stickyPrice, '[data-wbp-sticky-compare]', 'wb-product__sticky-compare');

    if (priceEl) priceEl.textContent = formattedPrice;
    if (atcPriceEl) atcPriceEl.textContent = formattedPrice;
    if (stickyPrice) stickyPrice.textContent = formattedPrice;

    [compareEl, atcCompareEl, stickyCompare].forEach(function(el) {
      if (!el) return;

      if (formattedCompare) {
        el.textContent = formattedCompare;
        el.style.display = '';
      } else {
        el.textContent = '';
        el.style.display = 'none';
      }
    });
  }

  function getSelectedUpsellState(section) {
    var card = section.querySelector('[data-wbuq-card].is-selected');
    if (!card) return null;

    var qty = readCents(card.getAttribute('data-qty')) || 1;
    var unitPrice = readCents(card.getAttribute('data-unit-price'));
    var manualTotal = readCents(card.getAttribute('data-manual-total-price'));
    var manualCompare = readCents(card.getAttribute('data-manual-compare-price'));

    var totalPrice = manualTotal > 0 ? manualTotal : unitPrice * qty;
    var comparePrice = manualCompare > totalPrice ? manualCompare : 0;

    return {
      qty: qty,
      unitPrice: unitPrice,
      totalPrice: totalPrice,
      comparePrice: comparePrice,
      hasManualPrice: manualTotal > 0
    };
  }

  function setupQtyOverride(section, data) {
    section._wbpQty = 1;
    section._wbpTotalPrice = 0;
    section._wbpComparePrice = 0;

    function apply(detail) {
      if (!detail || detail.sectionId !== data.sectionId) return;

      section._wbpQty = readCents(detail.qty) || 1;
      section._wbpTotalPrice = readCents(detail.totalPrice);
      section._wbpComparePrice = readCents(detail.comparePrice);

      updateMoneyDisplays(section, data, section._wbpTotalPrice, section._wbpComparePrice);

      var qtyInput = section.querySelector('[data-wbp-quantity-input]');
      if (qtyInput) qtyInput.value = section._wbpQty;
    }

    document.addEventListener('wbp:qty-override', function(e) {
      apply(e.detail);
    });

    var initial = getSelectedUpsellState(section);
    if (initial) {
      initial.sectionId = data.sectionId;
      apply(initial);
    }
  }

  function init() {
    var jsonEl = document.querySelector('[data-wbp-json]');
    if (!jsonEl) return;

    var data;
    try {
      data = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }

    var section = document.getElementById('wb-product-' + data.sectionId);
    if (!section) return;

    if (section.getAttribute('data-wbp-initialized') === 'true') return;
    section.setAttribute('data-wbp-initialized', 'true');

    setupQtyOverride(section, data);
    setupGallery(section, data);
    setupVariants(section, data);
    setupAddToCart(section, data);
    setupStickyBar(section);
    setupAccordions(section);
    setupFullscreen(section);
    setupBis(section);
    setupFade(section);
    setupDescToggle(section);
  }

  function setupGallery(section, data) {
    var slides = section.querySelector('[data-wbp-slides]');
    var prevBtn = section.querySelector('[data-wbp-prev]');
    var nextBtn = section.querySelector('[data-wbp-next]');
    var thumbs = section.querySelectorAll('[data-wbp-thumb]');
    var currentEl = section.querySelector('[data-wbp-current]');
    var totalEl = section.querySelector('[data-wbp-total]');
    var counterBox = section.querySelector('[data-wbp-counter]');

    if (!slides) return;

    var currentIndex = 0;
    var slideEls = section.querySelectorAll('[data-wbp-slide]');
    var total = slideEls.length;

    if (total <= 1 && counterBox) counterBox.style.display = 'none';
    if (total <= 0) return;
    if (totalEl) totalEl.textContent = total;

    function goTo(index) {
      if (index < 0 || index >= total) return;

      currentIndex = index;

      var target = slideEls[index];
      slides.scrollTo({
        left: target.offsetLeft,
        behavior: prefersReduced ? 'auto' : 'smooth'
      });

      updateControls();
    }

    function updateControls() {
      if (prevBtn) prevBtn.disabled = currentIndex === 0;
      if (nextBtn) nextBtn.disabled = currentIndex === total - 1;
      if (currentEl) currentEl.textContent = currentIndex + 1;

      thumbs.forEach(function(t) {
        var idx = parseInt(t.getAttribute('data-wbp-thumb'), 10);
        t.classList.toggle('is-active', idx === currentIndex);
      });
    }

    if (prevBtn) prevBtn.addEventListener('click', function() { goTo(currentIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function() { goTo(currentIndex + 1); });

    thumbs.forEach(function(t) {
      t.addEventListener('click', function() {
        goTo(parseInt(t.getAttribute('data-wbp-thumb'), 10));
      });
    });

    var scrollTimer = null;
    slides.addEventListener('scroll', function() {
      if (scrollTimer) return;

      scrollTimer = requestAnimationFrame(function() {
        scrollTimer = null;

        var slideWidth = slides.offsetWidth;
        if (slideWidth > 0) {
          var newIndex = Math.round(slides.scrollLeft / slideWidth);
          if (newIndex !== currentIndex && newIndex >= 0 && newIndex < total) {
            currentIndex = newIndex;
            updateControls();
          }
        }
      });
    });

    section._galleryGoTo = goTo;
  }

  function setupFullscreen(section) {
    if (section.getAttribute('data-fullscreen') !== 'true') return;

    var modal = document.createElement('div');
    modal.className = 'wb-product__fs-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Image en plein écran');
    modal.innerHTML =
      '<button class="wb-product__fs-close" aria-label="Fermer">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">' +
          '<path d="M18 6L6 18M6 6l12 12"/>' +
        '</svg>' +
      '</button>' +
      '<img class="wb-product__fs-img" src="" alt="">';

    document.body.appendChild(modal);

    var fsImg = modal.querySelector('.wb-product__fs-img');
    var closeBtn = modal.querySelector('.wb-product__fs-close');

    var slideEls = section.querySelectorAll('.wb-product__slide');
    slideEls.forEach(function(slide) {
      var img = slide.querySelector('img');
      if (!img) return;

      var btn = document.createElement('button');
      btn.className = 'wb-product__fs-btn';
      btn.setAttribute('aria-label', 'Ouvrir en plein écran');
      btn.innerHTML =
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">' +
          '<path d="M8 3H5a2 2 0 00-2 2v3m18 0V5a2 2 0 00-2-2h-3m0 18h3a2 2 0 002-2v-3M3 16v3a2 2 0 002 2h3"/>' +
        '</svg>';

      btn.addEventListener('click', function(e) {
        e.stopPropagation();

        var src = img.getAttribute('src') || '';
        var hiRes = src.indexOf('width=') !== -1 ? src.replace(/width=\d+/, 'width=2400') : src;

        fsImg.src = hiRes;
        fsImg.alt = img.alt || '';
        modal.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      });

      slide.appendChild(btn);
    });

    function closeModal() {
      modal.classList.remove('is-open');
      document.body.style.overflow = '';

      setTimeout(function() {
        if (!modal.classList.contains('is-open')) fsImg.src = '';
      }, 350);
    }

    closeBtn.addEventListener('click', closeModal);

    modal.addEventListener('click', function(e) {
      if (e.target === modal) closeModal();
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });
  }

  function setupVariants(section, data) {
    var product = data.product;
    var variantIdInput = section.querySelector('[data-wbp-variant-id]');
    var atcBtn = section.querySelector('[data-wbp-atc]');
    var atcText = section.querySelector('[data-wbp-atc-text]');
    var stockEl = section.querySelector('[data-wbp-stock]');
    var stockText = section.querySelector('[data-wbp-stock-text]');
    var bisBlock = section.querySelector('[data-wbp-bis]');
    var dynamicBtn = section.querySelector('.wb-product__dynamic-btn');

    if (!product || !product.variants) return;

    var selectedOptions = [];
    var firstVariant = null;

    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].id === data.initialVariantId) {
        firstVariant = product.variants[i];
        break;
      }
    }

    if (firstVariant && firstVariant.options) selectedOptions = firstVariant.options.slice();

    var optionBtns = section.querySelectorAll('[data-option-value]');
    optionBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var fieldset = btn.closest('[data-option-index]');
        var optionIndex = parseInt(fieldset.getAttribute('data-option-index'), 10);
        var value = btn.getAttribute('data-option-value');

        selectedOptions[optionIndex] = value;

        fieldset.querySelectorAll('[data-option-value]').forEach(function(b) {
          b.classList.toggle('is-selected', b.getAttribute('data-option-value') === value);
        });

        processVariantChange();
      });
    });

    var optionSelects = section.querySelectorAll('[data-option-select]');
    optionSelects.forEach(function(select) {
      select.addEventListener('change', function() {
        var fieldset = select.closest('[data-option-index]');
        var optionIndex = parseInt(fieldset.getAttribute('data-option-index'), 10);

        selectedOptions[optionIndex] = select.value;
        processVariantChange();
      });
    });

    function processVariantChange() {
      var variant = findVariant(product.variants, selectedOptions);
      if (variant) updateVariant(variant);
    }

    function findVariant(variants, options) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;

        for (var j = 0; j < options.length; j++) {
          if (v.options[j] !== options[j]) {
            match = false;
            break;
          }
        }

        if (match) return v;
      }

      return null;
    }

    function updateVariant(variant) {
      section._wbpCurrentVariant = variant;

      if (variantIdInput) variantIdInput.value = variant.id;

      var hasPromo = variant.compare_at_price && variant.compare_at_price > variant.price;
      updateMoneyDisplays(section, data, variant.price, hasPromo ? variant.compare_at_price : 0);

      if (atcBtn && atcText) {
        if (variant.available) {
          atcBtn.disabled = false;
          atcText.textContent = atcBtn.getAttribute('data-atc-text-default') || 'AJOUTER AU PANIER';

          if (bisBlock) bisBlock.style.display = 'none';
          if (dynamicBtn) dynamicBtn.style.display = '';
        } else {
          atcBtn.disabled = true;
          atcText.textContent = atcBtn.getAttribute('data-atc-text-sold') || 'ÉPUISÉ';

          if (bisBlock) bisBlock.style.display = '';
          if (dynamicBtn) dynamicBtn.style.display = 'none';
        }
      }

      if (stockEl && stockText) {
        if (!variant.available) {
          stockEl.setAttribute('data-state', 'out');
          stockText.textContent = 'Rupture de stock';
        } else {
          var mgt = data.management[variant.id];
          var qty = data.inventory[variant.id];

          if (mgt === 'shopify') {
            if (qty <= 5) {
              stockEl.setAttribute('data-state', 'low');
              stockText.textContent = 'Plus que ' + qty + ' en stock';
            } else if (qty <= 15) {
              stockEl.setAttribute('data-state', 'medium');
              stockText.textContent = 'Stock limité';
            } else {
              stockEl.setAttribute('data-state', 'in');
              stockText.textContent = 'En stock';
            }
          } else {
            stockEl.setAttribute('data-state', 'in');
            stockText.textContent = 'En stock';
          }
        }
      }

      if (variant.featured_media && section._galleryGoTo) {
        var mediaId = variant.featured_media.id;
        var slideEls = section.querySelectorAll('[data-wbp-slide]');

        slideEls.forEach(function(slide, idx) {
          if (parseInt(slide.getAttribute('data-media-id'), 10) === mediaId) {
            section._galleryGoTo(idx);
          }
        });
      }

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());

      document.dispatchEvent(new CustomEvent('wbp:variant-change', {
        bubbles: true,
        detail: {
          sectionId: data.sectionId,
          variantId: variant.id,
          price: variant.price,
          compareAtPrice: variant.compare_at_price || 0,
          available: variant.available
        }
      }));
    }

    if (firstVariant) {
      if (atcBtn) {
        atcBtn.setAttribute('data-atc-text-default', atcText ? atcText.textContent : 'AJOUTER AU PANIER');
        atcBtn.setAttribute('data-atc-text-sold', 'ÉPUISÉ');
      }

      updateVariant(firstVariant);
    }
  }

  function setupAddToCart(section, data) {
    var form = section.querySelector('.wb-product__buy form');
    var atcBtn = section.querySelector('[data-wbp-atc]');
    var stickyAtc = section.querySelector('[data-wbp-sticky-atc]');

    if (!form || !atcBtn) return;

    var quantityInput = form.querySelector('[data-wbp-quantity-input]');
    if (!quantityInput) {
      quantityInput = document.createElement('input');
      quantityInput.type = 'hidden';
      quantityInput.name = 'quantity';
      quantityInput.value = section._wbpQty || 1;
      quantityInput.setAttribute('data-wbp-quantity-input', '');
      form.appendChild(quantityInput);
    }

    function triggerSuccess(btn) {
      btn.classList.remove('is-loading');
      btn.classList.add('is-success');
      setTimeout(function() { btn.classList.remove('is-success'); }, 1800);
    }

    function handleSubmit(e) {
      e.preventDefault();

      if (atcBtn.disabled || atcBtn.classList.contains('is-loading')) return;

      atcBtn.classList.add('is-loading');
      if (stickyAtc) stickyAtc.classList.add('is-loading');

      var qty = parseInt(section._wbpQty, 10) || 1;

      quantityInput.value = qty;

      var formData = new FormData(form);
      formData.set('quantity', qty);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
        .then(function(r) {
          if (!r.ok) throw new Error('Cart add failed');
          return r.json();
        })
        .then(function() {
          triggerSuccess(atcBtn);
          if (stickyAtc) triggerSuccess(stickyAtc);

          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        })
        .catch(function() {
          atcBtn.classList.remove('is-loading');
          if (stickyAtc) stickyAtc.classList.remove('is-loading');
        });
    }

    form.addEventListener('submit', handleSubmit);

    if (stickyAtc) {
      stickyAtc.addEventListener('click', function() {
        if (atcBtn.disabled || atcBtn.classList.contains('is-loading')) return;
        form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      });
    }
  }

  function setupStickyBar(section) {
    var stickyBar = section.querySelector('[data-wbp-sticky-bar]');
    var atcBtn = section.querySelector('[data-wbp-atc]');

    if (!stickyBar || !atcBtn) return;

    var ticking = false;

    function onScroll() {
      if (ticking) return;

      ticking = true;

      requestAnimationFrame(function() {
        ticking = false;

        var rect = atcBtn.getBoundingClientRect();
        if (rect.bottom <= 0) {
          stickyBar.classList.add('is-visible');
        } else {
          stickyBar.classList.remove('is-visible');
        }
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function setupAccordions(section) {
    var toggleDescBtn = section.querySelector('[data-wbp-toggle-desc]');

    if (toggleDescBtn) {
      toggleDescBtn.addEventListener('click', function() {
        var descAccordion = section.querySelector('[data-acc-description]');

        if (descAccordion) {
          descAccordion.open = true;

          var y = descAccordion.getBoundingClientRect().top + window.scrollY - 80;
          window.scrollTo({
            top: y,
            behavior: prefersReduced ? 'auto' : 'smooth'
          });
        }
      });
    }
  }

  function setupDescToggle(section) {
    var btn = section.querySelector('[data-wbp-toggle-desc-inline]');
    if (!btn) return;

    var inner = section.querySelector('[data-wbp-desc-inner]');
    var full = section.querySelector('[data-wbp-desc-full]');
    if (!inner || !full) return;

    btn.addEventListener('click', function() {
      inner.style.display = 'none';
      full.style.display = 'block';
      btn.style.display = 'none';
    });
  }

  function setupBis(section) {
    var bisToggle = section.querySelector('[data-wbp-bis-toggle]');
    var bisForm = section.querySelector('[data-wbp-bis-form]');

    if (!bisToggle || !bisForm) return;

    bisToggle.addEventListener('click', function() {
      bisForm.style.display = 'block';
      bisToggle.style.display = 'none';
    });
  }

  function setupFade(section) {
    var fadeEls = section.querySelectorAll('.wb-fade');
    if (!fadeEls.length) return;

    if (prefersReduced) {
      fadeEls.forEach(function(el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.08,
      rootMargin: '0px 0px -32px 0px'
    });

    fadeEls.forEach(function(el, i) {
      if (!el.style.transitionDelay) {
        el.style.transitionDelay = Math.min(i * 0.05, 0.4) + 's';
      }

      observer.observe(el);
    });
  }

  document.addEventListener('shopify:section:load', function(e) {
    var section = e.target.querySelector('[data-wbp-json]');
    if (!section) return;

    var productSection = e.target.querySelector('.wb-product');
    if (productSection) productSection.removeAttribute('data-wbp-initialized');

    init();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();